import React from "react"
import { Button, Card, Col, Row, Typography } from "antd"
import { graphql, Link, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import MediaContext from "@avldev/gatsby-theme-core-ui/src/components/MediaContext"
import style from "./PackagesWidget.module.scss"

export default () => {
  const { width } = React.useContext(MediaContext)
  const [imageHeight, setImageHeight] = React.useState(250)
  const [numRows, setNumRows] = React.useState(3)

  React.useEffect(() => {
    if (width > 767 && width < 1000) {
      setImageHeight(200)
    } else setImageHeight(250)
  }, [width])

  React.useEffect(() => {
    if (imageHeight < 250) {
      setNumRows(3)
    } else setNumRows(5)
  }, [imageHeight])

  const { packages } = useStaticQuery(graphql`
    query {
      packages: allContentfulPackage(
        filter: {
          business: { elemMatch: { name: { in: "Residences at Biltmore" } } }
        }
        sort: { fields: name, order: ASC }
      ) {
        nodes {
          description {
            childMarkdownRemark {
              excerpt(pruneLength: 240)
            }
          }
          image {
            ...PackageImage
          }
          name
          page {
            slug
          }
        }
      }
    }
  `)

  if (!packages.nodes.length) return <></>

  return (
    <Row align="middle" justify="center" type="flex" className={style.wrapper}>
      <Col xs={23} md={22} lg={20} xl={18} xxl={16}>
        <Row align="middle" gutter={[24, 24]} justify="center" type="flex">
          <Col span={24} style={{ marginBottom: 12 }}>
            <Typography.Title
              level={4}
              style={{ fontSize: 32, textAlign: `center` }}
            >
              Plan Your Stay
            </Typography.Title>
          </Col>
          {packages.nodes.map(
            ({ description, image, name, page: { slug } }, index) => (
              <Col key={index} xs={23} md={8}>
                <Card
                  className={style.card}
                  cover={
                    <Img
                      alt={image.description}
                      fluid={image.fluid}
                      style={{
                        height: imageHeight,
                        margin: `auto`,
                        maxWidth: `100%`,
                      }}
                    />
                  }
                >
                  <Card.Meta
                    title={name}
                    description={
                      <Typography.Paragraph ellipsis={{ rows: numRows }}>
                        {description.childMarkdownRemark.excerpt}
                      </Typography.Paragraph>
                    }
                  />
                  <div style={{ marginTop: 16 }}>
                    <Link to={`/${slug}/`}>
                      <Button size="large" type="primary">
                        Learn More
                      </Button>
                    </Link>
                  </div>
                </Card>
              </Col>
            )
          )}
        </Row>
      </Col>
    </Row>
  )
}
